import React from 'react'
function Tile(val,pos_x,pos_y,cell_size,border_thickness,p5,tile_snap) {
   
    this.number=val;
    this.x=pos_x;
    this.y=pos_y;
    this.number_state=tile_snap;

    this.pos_x=this.x*(cell_size+border_thickness)+border_thickness+border_thickness/2;
    this.pos_y=this.y*(cell_size+border_thickness)+border_thickness+border_thickness/2;

    this.dest_x=this.pos_x;
    this.dest_y=this.pos_y;

    let one_pint=cell_size+border_thickness;
    let speed_fact=2;

    let transitioning=false;
    let error_est=1;
   

    



    this.t_pos_direct =(kv)=>{
        
        let a=Math.random();
        let xd=0;
        let yd=-1;           //this is kv==>0 == up
        if(kv==1)       //right 
            {
                xd=1;
                yd=0;
            }
        else if(kv==2)
        {
                xd=0;
                yd=1;   
        }
        else if(kv==3)
            {
                xd=-1;
                yd=0;
            }
        
            


        this.pos_x=(this.x-xd)*(cell_size+border_thickness)+border_thickness+border_thickness/2;
        this.pos_y=(this.y-yd)*(cell_size+border_thickness)+border_thickness+border_thickness/2;
    
        this.dest_x=this.x*(cell_size+border_thickness)+border_thickness+border_thickness/2;
        this.dest_y=this.y*(cell_size+border_thickness)+border_thickness+border_thickness/2;
    
    }


    this.double_val=()=>{
        this.number*=2;
    }
    
    this.zero_val=()=>{
        this.number=0;
    }

    this.set_val=(val)=>{
        this.number=val;
    }

  

    this.show=()=>{
        // p5.fill("green");
        if(this.number===0)
            return ;


        this.pos_x+=(this.dest_x-this.pos_x)/speed_fact;
        this.pos_y+=(this.dest_y-this.pos_y)/speed_fact;

        

        p5.fill(this.color_finder());
        p5.noStroke();
        p5.rect(this.pos_x,this.pos_y,cell_size,cell_size);
        p5.fill("black");
        p5.textAlign(p5.CENTER, p5.CENTER);
        p5.textSize(40);
        p5.text(this.number, this.pos_x+cell_size/2, this.pos_y+cell_size/2+border_thickness/2);
    }
    

    this.up=()=>{
        
        if(this.y>0)
        {
            this.y--;
            this.dest_y-=one_pint;
        }
    }

    this.down=()=>{
      

        if(this.y<3)
        {
            this.y++;
            this.dest_y+=one_pint;
        }
    }

    this.left=()=>{
       

        if(this.x>0)
        {
            this.x--;
            this.dest_x-=one_pint;
        }
    }

    this.right=()=>{
        if(this.x<3)
        {
            this.x++;
            this.dest_x+=one_pint;
        }
    }

    this.color_finder = ()=>{
        if(this.number==2)
            return "#EEE4DA"
        else if(this.number==4)
            return "#EEE1C9"
        
        else if(this.number==8)
            return "#F3B27A"
        else if(this.number==16)
            return "#F69664"
        else if(this.number==32)
            return "#F77C5F"
        else if(this.number==64)
            return "#ec5938"
        else if(this.number==128)
            return "#eccf73"
        else if(this.number==256)
            return "#f2d04b"

        return "yellow"
    }
    
   

}

export default Tile
